import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import FactoryHero from "./components/FactoryHero";
import ProcessOverview from "./components/ProcessOverview";
import FactoryGallery from "./components/FactoryGallery";
import FactoryCTA from "./components/FactoryCTA";

const FactoryPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <FactoryHero />
        <ProcessOverview />
        <FactoryGallery />
        <FactoryCTA />
      </main>
      <Footer />
    </div>
  );
};

export default FactoryPage;
